<template>
    <li class="col-span-1 flex items-center bg-white border border-gray-200 rounded-md shadow-sm overflow-hidden">
        <div class="flex-shrink-0 flex items-center justify-center w-16 h-16 text-white text-center text-sm leading-5 font-medium" :class="{ 'bg-green-600': count > 0, 'bg-gray-300': count <= 0 }">
            {{ count }} | {{ futureLicenses }}
        </div>

        <div class="flex-1 px-4 py-2">
            {{ type }}
        </div>
    </li>
</template>

<script>
    export default {
        props: {
            count: {
                type: Number,
                required: true,
            },
            futureLicenses: {
                type: Number,
                required: true,
            },
            type: {
                type: String,
                required: true,
            },
        },
    };
</script>
